<template>
    <div>
        <div class="header mt-5">
            {{ $vuetify.lang.t('$vuetify.companySetting.companySetting')}}
        </div>
        <nav-bar
        ref="navbar"
        @menu-change="menuChange"
        :menuItem="navbarList" />

        <component :is="component" />
    </div>
</template>

<script>
import NavBar from '@/components/NavBar.vue'
import CompanyProfile from '@/components/CompanySetting/CompanyProfile.vue'
import BranchList from '@/components/CompanySetting/BranchLists.vue'
import Blacklist from '@/components/CompanySetting/Blacklist.vue'
import SavePlace from '@/components/CompanySetting/SavePlace.vue'
import DepartmentList from '@/components/CompanySetting/DepartmentList.vue'
import UserList from '@/components/CompanySetting/UserList'
import CompanyHolidays from '@/components/CompanySetting/CompanyHolidays'
import permissionConstant from '@/constants/permissions.js'
import LineService from '@/components/CompanySetting/LineService'
import LeaveQuota from '@/components/TimeTableSetting/LeaveQuota.vue'
import LeaveTypeList from '@/components/CompanySetting/LeaveTypeList.vue'
export default {
    name: 'CompanySetting',

    components: {
        NavBar,
        CompanyProfile,
        BranchList,
        Blacklist,
        SavePlace,
        LeaveQuota,
        LeaveTypeList,
        DepartmentList,
        UserList,
        CompanyHolidays,
        LineService
    },

    data () {
        return {
            component: '',
            userPermissions: [],
            menuItem: [
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.profile'),
                    path: 'CompanyProfile',
                    pathName: 'company-profile',
                    permission: [permissionConstant.company.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.branch'),
                    path: 'BranchList',
                    pathName: 'branches',
                    permission: [permissionConstant.branch.view]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.userManagement'),
                    path: 'UserList',
                    pathName: 'user-list',
                    permission: [
                        permissionConstant.userManagement.superAdmin.view,
                        permissionConstant.userManagement.admin.view,
                        permissionConstant.userManagement.hr.view
                    ]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.department'),
                    path: 'DepartmentList',
                    pathName: 'departments',
                    permission: [permissionConstant.department.view]
                },
                {
                    title: 'Line Service',
                    path: 'LineService',
                    pathName: 'line-service',
                    permission: [permissionConstant.lineService.update]
                },
                {
                    title: this.$vuetify.lang.t('$vuetify.companySetting.companyHoliday'),
                    path: 'CompanyHolidays',
                    pathName: 'company-holiday',
                    permission: [permissionConstant.companyHoliday.update]
                },
                // {
                //     // LeaveQuota
                //     title: this.$vuetify.lang.t('$vuetify.companySetting.leaveQuota'),
                //     path: 'LeaveQuota',
                //     pathName: 'leave-quota',
                //     permission: [permissionConstant.leaveQuota.update]
                // },
                {
                    // LeaveType
                    title: this.$vuetify.lang.t('$vuetify.companySetting.leaveType'),
                    path: 'LeaveTypeList',
                    pathName: 'leave-type',
                    permission: [permissionConstant.leaveQuota.view]
                },
                {
                    // SavePlace
                    title: this.$vuetify.lang.t('$vuetify.companySetting.savePlace'),
                    path: 'SavePlace',
                    pathName: 'save-place',
                    permission: [permissionConstant.leaveQuota.view]
                },
                {
                    // BlackList
                    title: this.$vuetify.lang.t('$vuetify.companySetting.blacklist'),
                    path: 'Blacklist',
                    pathName: 'blacklist',
                    permission: [permissionConstant.blacklist.view]
                }
            ],
            mappedTranslation: {
                CompanyProfile: 'profile',
                BranchList: 'branch',
                UserList: 'userManagement',
                DepartmentList: 'department',
                CompanyHolidays: 'companyHoliday',
                LeaveQuota: 'leaveQuota',
                LeaveTypeList: 'leaveType',
                SavePlace: 'savePlace',
                Blacklist: 'blacklist'
            }
        }
    },

    computed: {
        navbarList () {
            const navbar = []
            for (let i = 0; i < this.menuItem.length; i++) {
                const show = this.menuItem[i].permission.some(p => this.userPermissions.includes(p))
                if (show) {
                    navbar.push(this.menuItem[i])
                }
            }
            return navbar
        }
    },

    methods: {
        hideServiceFromEnv () {
            if (process.env.VUE_APP_BLACKLIST === 'false') {
                const indexOfPinMenu = this.menuItem.findIndex((menu, index) => {
                    if (menu.path === 'Blacklist') {
                        return true
                    }
                })

                this.menuItem.splice(indexOfPinMenu, 1)
            }
        },

        setLangNavBar () {
            for (let i = 0; i < this.menuItem.length; i++) {
                if (this.mappedTranslation[this.menuItem[i].path]) {
                    this.menuItem[i].title = this.$vuetify.lang.t(`$vuetify.companySetting.${this.mappedTranslation[this.menuItem[i].path]}`)
                }
            }
        },

        menuChange (payload) {
            this.component = payload.path

            const path = `/company/setting/${this.navbarList[payload.index].pathName}`
            if (this.$route.path !== path) {
                this.$router.replace(path)
            }
        },

        navbarPermission () {
            this.component = this.navbarList[0].path
        },

        setActive (path) {
            let index = 0
            if (path === 'CompanySetting') {
                this.$refs.navbar.go(this.navbarList[0].pathName, index)
            } else {
                index = this.navbarList.findIndex(x => x.path === path)
                this.$refs.navbar.go(path, index)
            }

            const directPath = `/company/setting/${this.navbarList[index].pathName}`
            if (this.$route.path !== directPath) {
                this.$router.replace(directPath)
            }
        }
    },

    mounted () {
        this.hideServiceFromEnv()
        this.userPermissions = this.$store.state.permissions
        this.navbarPermission()
        this.setActive(this.$router.currentRoute.name)
    },

    watch: {
        '$vuetify.lang.current': {
            handler: function (after, before) {
                this.setLangNavBar()
            },
            deep: true
        }
    }
}
</script>

<style lang="scss" scoped>
.header {
    display: flex;
    justify-content: space-between;
    margin-bottom: 2rem;
    font-size: 28px;
    font-weight: bold;
}
</style>
